import dateFormat from "dateformat";
import { convertToMonthsAndDays } from "../../../../dates";
import { monitoringStatus } from "../../../../../types";
export const fieldsCgs: {
  [key: string]: { title: string; type: string };
} = {
  representative_id_number: { title: "წარმომადგენლის პირადი ნომერი", type: "text" },
  representative_position: { title: "წარმომადგენლის თანამდებობა", type: "text" },
  actual_address: { title: "სოფელი/ქუჩა, ქუჩის ნომერი", type: "text" }, //?
  actual_municipality: { title: "რეგიონი/ქალაქი/მუნიციპალიტეტი", type: "text" },
  mountainous_settlement: { title: "მთიანი დასახლება", type: "text" },
  representative_email: { title: "წარმომადგენლის ელ. ფოსტა", type: "text" },
  representative_name: { title: "წარმომადგენლის სახელი/გვარი", type: "text" },
  representative_phone: { title: "წარმომადგენლის ტელეფონი", type: "text" },
  representative_phone_secondary: { title: "დამატებით საკონტაქტო", type: "text" },
  representative_person_email: { title: "წარმომადგენლის ელ. ფოსტა", type: "text" },
  company_email: { title: "კომპანიის საჯარო ელ. ფოსტა", type: "text" },
  company_founder_phone: { title: "დამფუძნებლის ნომერი", type: "text" },
  approved: { title: "დადასტურებული / დახარვეზებული", type: "text" },
  comment: { title: "კომენტარი", type: "text" },
  approved_by: { title: "დაადასტურა / დახარვეზაბა", type: "text" },
  approved_at: { title: "დადასტურების / დახარვეზების თარიღი", type: "date" },
  ////
  machine_equipment_equipment: { title: "მანქანა - დანადგარები/აღჭურვილობა", type: "text" },
  targeted_machine_equipment_equipment: { title: "მანქანა - დანადგარები/აღჭურვილობა (მიზნობრივი ხარჯები)", type: "text" },
  nontargeted_machine_equipment_equipment: { title: "მანქანა - დანადგარები/აღჭურვილობა (არამიზნობრივი ხარჯები)", type: "text" },
  vehicles_special_technic: { title: "სატრანსპორტო საშუალებები/სპეც. ტექნიკა", type: "text" },
  targeted_vehicles_special_technic: { title: "სატრანსპორტო საშუალებები/სპეც. ტექნიკა (მიზნობრივი ხარჯები)", type: "text" },
  nontargeted_vehicles_special_technic: { title: "სატრანსპორტო საშუალებები/სპეც. ტექნიკა (არამიზნობრივი ხარჯები)", type: "text" },
  purchase_building_land: { title: "შენობა ნაგებობის/მიწის შეძენა", type: "text" },
  targeted_purchase_building_land: { title: "დადასტურების / დახარვეზების თარიღი", type: "date" },
  nontargeted_purchase_building_land: { title: "შენობა ნაგებობის/მიწის შეძენა (არამიზნობრივი ხარჯები)", type: "text" },
  building_repairs: { title: "მშენებლობა/რემონტი", type: "text" },
  targeted_building_repairs: { title: "დადასტურების / დახარვეზების თარიღი", type: "text" },
  nontargeted_building_repairs: { title: "მშენებლობა/რემონტი (მიზნობრივი ხარჯები)", type: "text" },
  fixed_assets_capital_expenditures: { title: "ძირითადი საშუალებები/კაპიტალური დანახარჯები", type: "text" },
  targeted_fixed_assets_capital_expenditures: { title: "მიზნობრივი ძირითადი საშუალებები/კაპიტალური დანახარჯები", type: "text" },
  nontargeted_fixed_assets_capital_expenditures: { title: "არამიზნობრივი ძირითადი საშუალებები/კაპიტალური დანახარჯები", type: "text" },
  funds_turnover: { title: "საბრუნავი საშუალებები", type: "text" },
  targeted_funds_turnover: { title: "საბრუნავი საშუალებები(მიზნობრივი)", type: "text" },
  nontargeted_funds_turnover: { title: "საბრუნავი საშუალებები (არამიზნობრივი)", type: "text" },
  used_amount: { title: "ათვისებული თანხის მოცულობა ₾", type: "text" },
  targeted_used_amount: { title: "მიზნობრივად ათვისებული თანხის მოცულობა", type: "text" },
  nontargeted_used_amount: { title: "არამიზნობრივად ათვისებული თანხის მოცულობა", type: "text" },
  ////
  unfulfilled_used_amount_reason: { title: "არდაკმაყოფილების მიზეზი", type: "text" },
  unfulfilled_used_amount_month_day: { title: "დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადა (თვე/დღე)", type: "text" },
  unfulfilled_used_amount_recommendation_reason: { title: "დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადისთვის გაცემული რეკომენდაცია", type: "text" },
  is_fullfilled_used_amount: { title: "სესხი არ/არის გახარჯული მიზნობრივად", type: "text" },
  is_loan_documentation_provided: {
    title: "სესხის ხარჯვის დოკუმენტაცია სრულად არის წარმოდგენილი",
    type: "text",
  },
  additional_comments: { title: "დამატებითი კომენტარი", type: "text" },
  monitoring_new_deadline: { title: "განმეორებითი მონიტორინგის ჩატარების თარიღი", type: "date" },
  is_new_deadline_approved: { title: "დადასტურება ვადის ცვლილების შესახებ დეპ. უფროსის მიერ", type: "text" },
  monitoring_deadline_comment: { title: "დარღვევის აღმოსაფხვრელად მიცემული ერთ წელზე მეტი ვადის დასტური დეპ. უფროსის მიერ", type: "text" },
  is_deadline_approve: { title: "ვადაგადაცილების დადასტურება", type: "text" },
  monitoring_approval_status: { title: "სტატუსი", type: "text" },
  monitoring_approval_deadline_comment: { title: "მონიტორინგის ვადაგადაცილების კომენტარი", type: "text" },
  is_taken_business_loan_leasing: {
    title: "სარგებლობდა საფინანსო ინსტიტუტების ბიზნესის მხარდამჭერი საკრედიტო პროდუქტებით (სესხი/ლიზინგი)",
    type: "text",
  },
  loan_id: { title: "სესხის ID", type: "text" },
};
export const valueFormatCgs = {
  is_repayment_amount: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_deadline_approve: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  monitoring_approval_status: (value: string) => monitoringStatus[value as keyof typeof monitoringStatus] ?? "",
  monitoring_deadline: (date: string) => (date ? dateFormat(date, "dd/mm/yyyy HH:MM:ss") : ""),
  monitoring_new_deadline: (date: Date | null) => (date ? dateFormat(date, "dd/mm/yyyy HH:MM:ss") : ""),
  is_new_deadline_approved: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_fullfilled_used_amount: (isTruthy: boolean) => (isTruthy ? "სესხი გახარჯულია მიზნობრივად" : "სესხი არ არის გახარჯული მიზნობრივად"),
  is_loan_documentation_provided: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  unfulfilled_used_amount_month_day: (value: number) => {
    const { months, days } = convertToMonthsAndDays(value);
    return `${months ?? 0}-თვე / ${days ?? 0}-დღე`;
  },
  contract_signed_date: (date: string) => (date ? dateFormat(date, "dd/mm/yyyy HH:MM:ss") : ""),
  jobs_created: (date: string) => (date ? dateFormat(date, "dd/mm/yyyy HH:MM:ss") : ""),
  first_tranche_date: (date: string) => (date ? dateFormat(date, "dd/mm/yyyy HH:MM:ss") : ""),
  start_activity_date: (date: string) => (date ? dateFormat(date, "dd/mm/yyyy HH:MM:ss") : ""),
  approved_at: (date: string) => (date ? dateFormat(date, "dd/mm/yyyy HH:MM:ss") : ""),
  approved: (value: boolean | undefined) => (value ? "დადასტურდა" : value === false ? "დახარვეზდა" : "განსახილველი"),
  is_taken_business_loan_leasing: (value: boolean | undefined) => (typeof value === "undefined" ? "უცნობია" : value ? "კი" : "არა"),
};
